import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../Style.scss";
import "./Style.scss";

const sitemapSections = [
  {
    title: "Main",
    links: [
      { label: "Home", to: "/" },
      { label: "About", to: "/" },
      { label: "Contact Us", to: "/contact" },
      { label: "Downloads", to: "/download" },
      { label: "Open a Trading Account", to: "/step-by-step" },
      { label: "Create a Ticket", to: "/ticket" },
    ],
  },
  {
    title: "Investor",
    links: [
      { label: "Investor Grievance", to: "/investor-grievance" },
      { label: "Do's & Don'ts", to: "/do-dont" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Disclaimer", to: "/disclaimer" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "NSE Arbitration Rules", to: "/nse-arbitration-rules" },
      { label: "Broker Norms", to: "/broker-norms" },
      { label: "Policy & Procedure", to: "/policy-procedure" },
    ],
  },
  {
    title: "External Resources",
    links: [
      { label: "NSE", to: "https://www.nseindia.com/", external: true },
      { label: "BSE", to: "https://www.bseindia.com/", external: true },
      { label: "SEBI", to: "https://www.sebi.gov.in/", external: true },
      { label: "NSDL", to: "https://nsdl.co.in/", external: true },
      { label: "CDSL", to: "https://www.cdslindia.com/index.html", external: true },
      { label: "RBI", to: "https://www.rbi.org.in/", external: true },
    ],
  },
];

function SitemapLink({ link }) {
  if (link.external) {
    return (
      <a href={link.to} target="_blank" rel="noopener noreferrer">
        {link.label}
      </a>
    );
  }

  return <Link to={link.to}>{link.label}</Link>;
}

export default function Sitemap() {
  return (
    <>
      <Helmet>
        <title>Sitemap ~ Algoquant Global</title>
      </Helmet>
      <div className="wrapper sitemapContainer">
        <div className="sitemapHeader container headerforall">
          <div className="leftHeader">
            <h1>SITEMAP</h1>
          </div>
          <div className="rightHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/" className="inActive">
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Sitemap
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <hr width="100%" />
        <Container className="sitemap paragraphforall">
          <p className="disc">
            Browse all pages and resources available on the Algoquant Global
            website.
          </p>
          <Row className="sitemapRows">
            {sitemapSections.map((section) => (
              <Col key={section.title} lg={3} md={6} sm={12} className="mb-4">
                <div className="sitemapSection">
                  <h5 className="heading">{section.title}</h5>
                  <ul className="sitemapList">
                    {section.links.map((link) => (
                      <li key={link.label} className="sitemapItem">
                        <SitemapLink link={link} />
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
}
